<div class="component">
  <div class="{{ui}}cards" part="cards">
    {{>slot}}
  </div>
</div>
